module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Magic-51db42c22b7083b07ba949c8cdc71c37.svg";